import { Card } from "./components/card";
import { JiraIssue } from "./constants/types";
import { columnStyle, columnTitleStyle } from "./jsw-interactive-board.styles";

interface ColumnProps {
    title: string;
    cards: JiraIssue[];
}

export const Column = ({ title, cards }: ColumnProps) => {
    return (
        <div css={columnStyle}>
            <h3 css={columnTitleStyle}>{title}</h3>
            <div role="list">
                {cards.map((card, i) => {
                    return (
                        card.id && (
                            <Card
                                key={i}
                                role="listitem"
                                priority={card.priority}
                                epicName={card.epicName}
                                assignee={card.assignee}
                                issueType={card.issueType}
                                summary={card.summary}
                                id={card.id}
                            />
                        )
                    );
                })}
            </div>
        </div>
    );
};
